/**
 * Platform enum defining the supported platforms for the application
 */
enum Platform {
  TV = "tv",
  Web = "web",
  Mobile = "mobile",
}

export { Platform };
